import { isEmpty } from 'lodash';
import styled, { css } from 'styled-components';

export const DataRow = styled.div`
  display: grid;
  grid-template-rows: ${({ bottomContainer }) => (isEmpty(bottomContainer) ? '1fr' : '1fr 1fr')};
  margin: 16px;
  padding: 16px;
  ${({ card, left, right }) => {
    if (card && left) {
      return css`
        margin-left: 0;
      `;
    } else if (card && right) {
      return css`
        margin-right: 0;
      `;
    }
  }}
  box-sizing: border-box;
  width: ${({ noAlign }) => {
    if (noAlign) {
      return css`calc(50% - 32px)`;
    }
    return css`calc(33.3% - 32px)`;
  }};
  min-width: 320px;
  ${({ bottomContainer }) =>
    !isEmpty(bottomContainer) &&
    css`
      grid-row-gap: 16px;
    `};
  ${({ card }) => {
    if (card) {
      return css`
        border: thin solid #eee;
        box-shadow: 1px 8px 40px rgba(0, 0, 0, 0.15);
      `;
    }
  }};

  @media only screen and (max-width: 1084px) {
    margin-left: ${({ hideLeftMargin }) => (hideLeftMargin ? 0 : '16px')};
  }

  @media only screen and (max-width: 768px) {
    grid-template-rows: auto;
    margin: 8px;
    width: calc(100% - 16px);
  }

  @media print {
    margin: 8px;
    padding: 4px;
    min-width: 200px;
  }
`;
